import React from 'react';
import { Checkbox, Button, Modal } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import styles from './AdvertisementModal.module.scss';

const AdvertisementModal = ({ open, onClose, onToggleDontShow, header, children, size }) => {
	const sizeMapping = ['tiny', 'mini', 'small', 'large'];
	if (isNaN(parseInt(size))) {
		size = Math.max(sizeMapping.indexOf(size), 0);
	}

	return (
		<Modal open={open} size={sizeMapping[size]}>
			<Modal.Header className={styles.header}>{header}</Modal.Header>
			<Modal.Content scrolling>
				<div className={styles.container}>
					{children}
					<div className={styles.footer}>
						<div className={styles.check}>
							<Checkbox label='Do not show anymore.' onChange={onToggleDontShow} />
						</div>
					</div>
				</div>
			</Modal.Content>
			<Modal.Actions>
				<Button primary content='Close' onClick={onClose} />
			</Modal.Actions>
		</Modal>
	);
};

AdvertisementModal.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onToggleDontShow: PropTypes.func.isRequired,
};

export default AdvertisementModal;
